import { Link } from "react-router-dom";
import BrandMark from "@/components/base/BrandMark";
import NewsletterForm from "@/components/feature/NewsletterForm";
import { categories } from "@/mocks/categories";
import { contactInfo } from "@/mocks/site";

const siteLinks = [
  { to: "/", label: "首页" },
  { to: "/archive", label: "复盘档案库" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系与合作" },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-accent-900/40 bg-primary-950">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <BrandMark />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-foreground-700">
              把旧账翻出来重新捋一遍。我们只整理公开信息，按时间线还原事件全貌，让来龙去脉一眼可见。
            </p>
            <div className="mt-6">
              <p className="mb-3 flex items-center gap-2 text-xs tracking-[0.2em] text-accent-400">
                <i className="ri-mail-send-line text-base" />
                深夜速递
              </p>
              <NewsletterForm />
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-sm tracking-[0.2em] text-accent-400">内容分类</h3>
            <ul className="mt-5 space-y-3">
              {categories.map((item) => (
                <li key={item.id}>
                  <Link
                    to="/archive"
                    className="flex items-center gap-2 text-sm text-foreground-700 transition-colors duration-200 hover:text-foreground-950 cursor-pointer"
                  >
                    <i className="ri-arrow-right-up-line text-base text-accent-500/80" />
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-sm tracking-[0.2em] text-accent-400">站点页面</h3>
            <ul className="mt-5 space-y-3">
              {siteLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-700 transition-colors duration-200 hover:text-foreground-950 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-sm tracking-[0.2em] text-accent-400">联系我们</h3>
            <ul className="mt-5 space-y-3 text-sm text-foreground-700">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base text-accent-500/80" />
                <a
                  href={`mailto:${contactInfo.email}`}
                  rel="nofollow"
                  className="break-all transition-colors duration-200 hover:text-foreground-950"
                >
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-lightbulb-line mt-0.5 text-base text-accent-500/80" />
                <a
                  href={`mailto:${contactInfo.tipEmail}`}
                  rel="nofollow"
                  className="break-all transition-colors duration-200 hover:text-foreground-950"
                >
                  {contactInfo.tipEmail}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-base text-accent-500/80" />
                <span>{contactInfo.responseTime}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-accent-900/40 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 深夜黑料 · 事件复盘档案库　内容基于公开信息整理，仅供参考与讨论。
          </p>
          <p className="text-xs text-foreground-500">
            本站不提供任何未公开的私人信息，如涉及版权问题请邮件联系。
          </p>
        </div>
      </div>
    </footer>
  );
}